// extracted by mini-css-extract-plugin
export default {"overlay":"styles__overlay___u2ket","overlay-image":"styles__overlay-image___Xh29Z"};